import { render, staticRenderFns } from "./QualificationList.vue?vue&type=template&id=a8febc4c"
import script from "./QualificationList.js?vue&type=script&lang=js&external"
export * from "./QualificationList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports